import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { EditPiaDrawer } from './EditPiaDrawer';
import { ReviewPiaDrawer } from './ReviewPiaDrawer';

export const StartPiaDrawer = ({
  isOpen,
  setIsOpen,
  applicationId,
  policy,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  applicationId: number;
  policy: string;
}) => {
  const [reason, setReason] = useState<string>('');
  const [isReview, setIsReview] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setReason('');
    }
  }, [isOpen]);

  return (
    <>
      {isReview && (
        <ReviewPiaDrawer
          applicationId={applicationId}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setIsReview={setIsReview}
          reason={reason}
          policy={policy}
        />
      )}
      {!isReview && (
        <EditPiaDrawer
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setIsReview={setIsReview}
          setReason={setReason}
          reason={reason}
        />
      )}
    </>
  );
};
